var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "statistics-details-root" },
    [
      _vm._l(_vm.statisticsDetails, function(ref, index) {
        var typeLabel = ref.label
        var values = ref.values
        return [
          _c(
            "div",
            {
              key: typeLabel + "-" + index,
              staticClass: "statistics-details-table-container"
            },
            [
              _c("table", { staticClass: "statistics-details-table" }, [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c(
                        "th",
                        {
                          staticClass:
                            "statistics-details-label-cell set-label-cell"
                        },
                        [_vm._v(" ")]
                      ),
                      _vm._v(" "),
                      _vm._l(values, function(ref, index) {
                        var label = ref.label
                        return _c(
                          "th",
                          {
                            key: label + "-" + index,
                            staticClass:
                              "statistics-details-label-cell values-label-cell",
                            class: {
                              selected:
                                _vm.selectedTypeFiltersLookup[typeLabel][label]
                            },
                            attrs: {
                              width: _vm.cellWidthPerType[typeLabel] + "%"
                            },
                            on: {
                              click: function($event) {
                                return _vm.filterSelected(typeLabel, label)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(label) +
                                "\n                    "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c(
                    "tr",
                    [
                      _c(
                        "td",
                        {
                          staticClass:
                            "statistics-details-label-cell set-label-cell"
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(typeLabel) +
                                "\n                        "
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(values, function(ref, index) {
                        var value = ref.value
                        var label = ref.label
                        return _c(
                          "td",
                          {
                            key: label + "-" + index,
                            staticClass: "values-label-cell",
                            class: {
                              selected:
                                _vm.selectedTypeFiltersLookup[typeLabel][label]
                            },
                            attrs: {
                              width: _vm.cellWidthPerType[typeLabel] + "%"
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm._f("formatNumber")(value)) +
                                "\n                    "
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }